import { Component, Input, OnInit } from '@angular/core';
import { AppComponentName, ExportData, ExportDataCriteria, ExportSaveAs, InterpolationInterval, InterpolationMethod, Message, MessageActionType, MessageType, Sensor, SensorReadingType, TimeZoneDisplay } from '@models';
import { AIDataContext } from '@models/AI/AIDataContext.model';
import { AIMessage } from '@models/AI/AIMessage.model';
import { AIResponse } from '@models/AI/AIResponse.model';
import { AskQuestionRequest } from '@models/AI/AskQuestionRequest.model';
import { SensorReadingInfo } from '@models/EventLog/SensorReadingInfo.model';
import { AIService } from '@services/ai.service';
import { AppMessageService } from '@services/message.service';
import { SensorService } from '@services/sensor.service';
import { UserService } from '@services/user.service';
import { add } from 'lodash';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

@Component({
  standalone: false,
  selector: 'ai-readings-modal',
  templateUrl: './ai-readings-modal.component.html',
  styleUrls: ['./ai-readings-modal.component.scss']
})

export class AiReadingsModalComponent implements OnInit {

  @Input() sensors: Sensor[];
  @Input() sensorReadings: SensorReadingInfo[];
  @Input() sensorReadingTypes: SensorReadingType[];
  @Input() includeOrigValues: boolean;
  @Input() includeCalValues: boolean;

  askAIQuestion: string = '';
  askAIResponse: AIResponse = { content: '', isSuccess: false, errorMessage: '', tokensUsed: 0, timestamp: new Date(), model: '', metadata: {} };
  askAIWaiting: boolean = false;
  askAIHistory: AIMessage[] = [];
  askAIDisplay: string = '';

  modalDragOn: boolean = false;
  exportOptionsModalRef: BsModalRef;
  username = 'unknown';


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService, private _aiService: AIService,
              public _sensorService: SensorService, public _userService: UserService, public _appMessageService: AppMessageService) {
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
  
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  ngOnChanges() {

  }


  prepareJsonContextForAI(): string {
    if (this.sensorReadings == null || this.sensorReadings.length == 0) {
      return 'No sensor readings available.';
    }

    var aiDataContext: AIDataContext[] = [];

    this.sensorReadings.forEach(reading => {
      var dataContext: AIDataContext = {
        uid: reading.uuid,
        value: reading.value,
        readingType: reading.type,
        timestamp: reading.createdDate,
        sensorName: ''
      };
      aiDataContext.push(dataContext);
    });
    
    return JSON.stringify(aiDataContext);
  }


  prepareCsvContextForAI(): string {
    if (this.sensorReadings == null || this.sensorReadings.length == 0) {
      return 'No sensor readings available.';
    }

    var csvContext: string = 'Timestamp,SensorName,SensorUUID,ReadingType,Value,OrigValue\n';

    this.sensorReadings.forEach(reading => {  
      csvContext += `${reading.createdDate},${reading.sensorName},${reading.uuid},${reading.type},${reading.value},${reading.origValue}\n`;
    });

    return csvContext;
  }


  addMessageToAIHistory(role: 'user' | 'assistant', content: string) {
    var message: AIMessage = {
      role: role,
      content: content,
      timestamp: moment().local().toDate()
    };
    this.askAIHistory.push(message);
  }

  
  askAI() {
    if (this.askAIQuestion == null || this.askAIQuestion.trim() == '') {
      this.toastr.error('Please enter a question for AI');
      return;
    }

    this.askAIWaiting = true;

    var content = (this.askAIHistory.length == 0) ? this.askAIQuestion + '\n' + this.prepareCsvContextForAI() : this.askAIQuestion;

    this.addMessageToAIHistory('user', content);

    this.askAIDisplay += 'User\n' + this.askAIQuestion + '\n\n';
    
    var askAIQuestionRequest: AskQuestionRequest = {
      question: content,
      context: '',  
      history: this.askAIHistory
    };
    

    this._aiService.askAI(askAIQuestionRequest).subscribe(
      (response: any) => {
        this.askAIResponse = response;
        this.askAIWaiting = false;
        this.addMessageToAIHistory('assistant', this.askAIResponse.content);
        this.askAIDisplay += 'Assistant\n' + this.askAIResponse.content + '\n\n';
      },
      (error) => {
        this.toastr.error('Error occurred while asking AI');
        this.askAIWaiting = false;
      }
    );

    this.askAIQuestion = '';
  }


  clearDisplay() {
    this.askAIDisplay = '';
  }


  newConversation() {
    this.askAIResponse = { content: '', isSuccess: false, errorMessage: '', tokensUsed: 0, timestamp: new Date(), model: '', metadata: {} };
    this.askAIQuestion = '';
    this.askAIHistory = [];
    this.askAIDisplay = '';
  }


}
